import {
  Alert,
  Anchor,
  Badge,
  Button,
  Checkbox,
  createTheme,
  DEFAULT_THEME,
  getDefaultZIndex,
  InputWrapper,
  LoadingOverlay,
  Modal,
  MultiSelect,
  NavLink,
  NumberFormatter,
  Paper,
  Popover,
  Radio,
  Select,
  Stack,
  TabsPanel,
  Text,
} from '@mantine/core';

const theme = createTheme({
  primaryColor: 'blue',
  components: {
    Alert: Alert.extend({
      defaultProps: {
        mt: 'md', // Offset from previous element
        pb: 'md',
      },
    }),
    Anchor: Anchor.extend({
      defaultProps: {
        c: 'blue',
      },
      styles: {
        root: {
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    }),
    Badge: Badge.extend({
      defaultProps: {
        variant: 'light',
        radius: 'xs',
        color: 'blue',
      },
    }),
    Button: Button.extend({
      defaultProps: {
        variant: 'filled',
      },
    }),
    Checkbox: Checkbox.extend({
      styles: {
        input: {
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '&:focus-visible': {
            outline: 'none',
            boxShadow: 'none',
          },
        },
      },
    }),
    InputWrapper: InputWrapper.extend({
      styles: {
        label: {
          fontSize: '1rem',
        },
        description: {
          marginBottom: '1px',
        },
      },
    }),
    LoadingOverlay: LoadingOverlay.extend({
      defaultProps: {
        overlayProps: { blur: 2 },
        // Mantine's default (400) paints in-page overlays over the app shell (100) and the chat drawer (200).
        zIndex: getDefaultZIndex('app') - 1,
      },
    }),
    Modal: Modal.extend({
      defaultProps: {
        size: 'auto',
        centered: true,
        overlayProps: {
          backgroundOpacity: 0.55,
          blur: 2,
        },
        styles: {
          title: {
            fontSize: DEFAULT_THEME.fontSizes.xl,
            fontWeight: DEFAULT_THEME.headings.fontWeight,
          },
        },
      },
    }),
    NavLink: NavLink.extend({
      styles: {
        root: {
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '&:focus-visible': {
            outline: 'none',
            boxShadow: 'none',
          },
        },
        body: {
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '&:focus-visible': {
            outline: 'none',
            boxShadow: 'none',
          },
        },
      },
    }),
    NumberFormatter: NumberFormatter.extend({
      defaultProps: {
        decimalScale: 0,
      },
    }),
    Paper: Paper.extend({
      defaultProps: {
        p: 'md',
        withBorder: true,
      },
    }),
    Popover: Popover.extend({
      styles: {
        dropdown: {
          border: '1px solid var(--mantine-color-gray-5)',
          borderRadius: 5,
        },
      },
      defaultProps: {
        shadow: 'xl',
      },
    }),
    Select: Select.extend({
      defaultProps: {
        withScrollArea: false,
      },
      styles: {
        options: {
          maxHeight: 220,
          overflowY: 'auto',
          overscrollBehavior: 'contain',
          scrollbarWidth: 'thin',
        },
      },
    }),
    MultiSelect: MultiSelect.extend({
      defaultProps: {
        withScrollArea: false,
      },
      styles: {
        options: {
          maxHeight: 220,
          overflowY: 'auto',
          overscrollBehavior: 'contain',
          scrollbarWidth: 'thin',
        },
      },
    }),
    RadioGroup: Radio.Group.extend({
      styles: {
        label: {
          marginBottom: '0.5rem',
        },
      },
    }),
    Stack: Stack.extend({
      defaultProps: {
        gap: 'sm',
      },
    }),
    Text: Text.extend({
      defaultProps: {
        size: 'sm',
        c: 'dimmed',
      },
    }),
    TabsPanel: TabsPanel.extend({
      defaultProps: {
        pt: 'md',
      },
    }),
  },
});

export default theme;
